import Vue from "vue";
import Swal from "sweetalert2";
let ImgSrcConnect = "./flipcode_icon_ble_connected.png";
let ImgSrcDisConnect = "./flipcode_icon_ble_disconnected.png";

const swalToast = Swal.mixin({
  toast: true,
  timer: 3000,
  showConfirmButton: false,
  customClass: {
    container: "custom-confirm custom-toast",
    confirmButton: "button button-confirm",
    cancelButton: "button button-cancel"
  },
  onOpen: toast => {
    toast.addEventListener("mouseenter", Swal.stopTimer);
    toast.addEventListener("mouseleave", Swal.resumeTimer);
  },
  buttonsStyling: false
});

const toast = {
  namespaced: true,
  state: {},
  mutations: {
    connectSuccess(state, payload) {
      console.log("payload", payload);
      let device = payload || {};
      let { name = "" } = device;

      swalToast.fire({
        title: `<img src=${ImgSrcConnect} class="toast-img"/> <span>${name} Connected.</span>`
      });

      // Vue.toasted.show(`${name} 連線成功。`, {
      //   theme: "outline",
      //   icon: {
      //     name: "connectSuccess-svg"
      //   }
      // });
    },
    //目前沒看過連線失敗 之後有機會再補
    //isOpen is Boolean
    reconnecting(state, payload) {
      let { left, device = {} } = payload;

      let { name = "" } = device;
      swalToast.fire({
        title: `<span>${name} Try Reconnecting. ${left} times left. </span>`
      });
    },
    reconnectResult(state, payload) {
      let { success, device = {} } = payload;

      let { name = "" } = device;

      success
        ? swalToast.fire({
            title: `<span>${name} Reconnection Successful. </span>`
          })
        : swalToast.fire({
            title: `<span>${name} Reconnection Failed.</span>`
          });
    },
    bleDisconnectToast(state, payload) {
      let { manually, device = {} } = payload;

      let { name = "" } = device;

      swalToast.fire({
        title: `<img src=${ImgSrcDisConnect} class="toast-img"/> <span>${name} Disconnected.</span>`
      });

      // manually
      //   ? Vue.toasted.show(`${name}  手動斷線`, {
      //       theme: "outline",
      //       icon: {
      //         name: "finish-svg"
      //       }
      //     })
      //   : Vue.toasted.show(`${name}  異常斷線`, {
      //       theme: "outline",
      //       icon: {
      //         name: "error-svg"
      //       }
      //     });
    }
  },
  actions: {},
  getters: {}
};

export default toast;
